import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { parseSearch } from "../../../actions/helpers";
import { setHazard } from "../../../actions/filters";

const PREFIX = 'Hazard';

const classes = {
  root: `${PREFIX}-root`,
  formControl: `${PREFIX}-formControl`,
  selectEmpty: `${PREFIX}-selectEmpty`,
  menuItem: `${PREFIX}-menuItem`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.formControl}`]: {
    margin: theme.spacing(1),
    minWidth: "12rem",
  },

  [`& .${classes.selectEmpty}`]: {
    marginTop: theme.spacing(2),
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      background: "#fff",
      padding: "0 0.7em",
    },
  },

  [`& .${classes.menuItem}`]: {
    textTransform: "capitalize",
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Hazard = ({ hazard, setHazard }) => {

  const history = useHistory();
  const filter = Object.keys(hazard).filter((key) => hazard[key]);

  const setHistory = (key, param) => {
    const searchParams = parseSearch();
    param.length === 0 ? delete searchParams[key] : (searchParams[key] = param);
    const params = new URLSearchParams(searchParams).toString();
    const search = params.includes("?") ? `${params}` : `?${params}`;
    history.push({
      pathname: "/details",
      search: search,
    });
  };

  const handleChange = (event) => {
    const _hazard = {};
    const values = event.target.value;
    Object.keys(hazard).map((key) => (_hazard[key] = false));
    values.map((val) => (_hazard[val.toLowerCase()] = true));
    setHazard(_hazard);
    setHistory("hazard", `${values}`);
  };

  useEffect(() => {
    if (!parseSearch().hazard) {
      setHistory(
        "hazard",
        `${Object.keys(hazard).filter((key) => hazard[key])}`
      );
    }
  }, [hazard]);

  return (
    <Root className={classes.root}>
		<div>
	      <FormControl className={classes.formControl}>
	        <InputLabel>Hazard Filter</InputLabel>
	        <Select
	          multiple
	          value={filter}
	          onChange={handleChange}
	          input={<Input />}
	          renderValue={(selected) => selected.join(", ")}
	          MenuProps={MenuProps}
	        >
	          {Object.keys(hazard).map((val) => (
	            <MenuItem className={classes.menuItem} key={val} value={val}>
	              <Checkbox checked={filter.indexOf(val) > -1} />
	              <ListItemText primary={val} />
	            </MenuItem>
	          ))}
	        </Select>
	      </FormControl>
		</div>
    </Root>
  );
};

Hazard.propTypes = {
  setHazard: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  hazard: state.filters.hazard,
});

export default connect(mapStateToProps, { setHazard })(Hazard);
